// AI Generated Component
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AccessibilityPdfService } from '@client/app/blocks/service/accessibility/pdf-accessibility.service';

@Component({
    selector: 'document-details-section-accessibility-wcag20-table',
    standalone: false,
    template: `
        <table-container [collection]="checks" [progress]="progress">
            <table class="table table-hover table-fixed">
                <thead>
                <tr>
                    <th class="col-4">&nbsp;</th>
                    <th class="col-38" translate>
                        Check name
                    </th>
                    <th class="col-6 text-right pr-3" translate>
                        Errors
                    </th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngIf="!document.clarity_tagged">
                    <tr *ngFor="let check of checks; trackBy: trackByIndex">
                        <td class="text-center">
                            <span class="fa-stack fa-lg">
                              <span class="fa-stack-2x" [ngClass]="getIconContainer(check)"></span>
                              <span class="fa-stack-1x" [ngClass]="getIcon(check)"></span>
                            </span>
                        </td>
                        <td class="text-v-middle">
                            {{check.name}}
                        </td>
                        <td class="text-right text-v-middle pr-3">
                            {{check.errors_count | number}}
                        </td>
                    </tr>
                </ng-container>
                <ng-container *ngIf="document.clarity_tagged">
                    <tr *ngFor="let check of checks; trackBy: trackByIndex"
                        [ngClass]="{'active': activeCheck.id === check.id}"
                        (click)="selectCheck.emit(check)">
                        <td class="text-center">
                            <span class="fa-stack fa-lg">
                              <span class="fa-stack-2x" [ngClass]="getIconContainer(check)"></span>
                              <span class="fa-stack-1x" [ngClass]="getIcon(check)"></span>
                            </span>
                        </td>
                        <td class="text-v-middle">
                            {{check.name}}
                        </td>
                        <td class="text-right text-v-middle pr-3">
                            {{check.errors_count | number}}
                        </td>
                    </tr>
                </ng-container>
                </tbody>
            </table>
        </table-container>
    `,
})
export class DocumentDetailsAccessibilityWcag20TableComponent {
    @Input() checks: any;
    @Input() activeCheck: any;
    @Input() progress: any;
    @Input() document: any;
    @Output() selectCheck = new EventEmitter<any>();

    constructor (private accessibilityPdfAccessibilityService: AccessibilityPdfService) {}

    getIconContainer (check: any): any {
        return this.accessibilityPdfAccessibilityService.getDocumentIconContainer(this.document, check);
    }

    getIcon (check: any): any {
        return this.accessibilityPdfAccessibilityService.getDocumentIcon(this.document, check);
    }

    trackByIndex (index: number): number {
        return index;
    }
}
